/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    unit: "USD",
    title: "Giá chuyển nhượng",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    unit: "USD",
    index: "2",
    title: "Giá mua của phần quyền lợi chuyển nhượng",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    unit: "USD",
    title: "Chi phí chuyển nhượng",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    unit: "USD",
    title: "Thu nhập từ hoạt động chuyển nhượng quyền lợi [30]=[27]-[28]-[29]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    unit: "%",
    title: "Thuế suất",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    unit: "USD",
    title: "Số thuế thu nhập doanh nghiệp phải nộp [32]=[30]x[31]",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => ["4", "6"].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  [{index + 27}]
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.index) ? (
                    "0,00"
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
